// contexts/UploadProgressContext.tsx
import { createContext, useContext, useState } from "react";

interface UploadProgressContextType {
  uploadPercentage: number;
  isProcessing: boolean;
  setUploadPercentage: (value: number | ((prev: number) => number)) => void;
  setProcessing: (isProcessing: boolean) => void;
  resetUpload: () => void;
}

const UploadProgressContext = createContext<
  UploadProgressContextType | undefined
>(undefined);

export const UploadProgressProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const [isProcessing, setProcessing] = useState(false);

  const resetUpload = () => {
    setUploadPercentage(0);
    setProcessing(false);
  };

  return (
    <UploadProgressContext.Provider
      value={{
        uploadPercentage,
        isProcessing,
        setUploadPercentage,
        setProcessing,
        resetUpload,
      }}
    >
      {children}
    </UploadProgressContext.Provider>
  );
};

export const useUploadProgress = () => {
  const context = useContext(UploadProgressContext);
  if (!context) {
    throw new Error(
      "useUploadProgress must be used within an UploadProgressProvider"
    );
  }
  return context;
};
